import React, { useState, useEffect } from 'react';
import { useNavigate, Outlet } from 'react-router-dom';
import CommonSidebar from './CommonSidebar';
import axiosInstance from '../services/axiosInstance';

const Layout = () => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (!token) {
            navigate('/login');
            return;
        }

        const fetchUserData = async () => {
            try {
                const response = await axiosInstance.get('/auth/verify-token');
                const data = response.data;

                if (data.success && data.user.verified) {
                    setUser(data.user);
                } else {
                    navigate('/login');
                }
            } catch (error) {
                console.error('Error fetching user data:', error);
                navigate('/login');
            } finally {
                setLoading(false);
            }
        };

        fetchUserData();
    }, [navigate]);

    const handleLogout = () => {
        localStorage.removeItem('token');
        navigate('/login');
    };

    if (loading) {
        return (
            <div className="flex justify-center items-center h-screen w-screen bg-gradient-to-br from-slate-50 to-slate-200">
                <div className="w-12 h-12 border-4 border-indigo-200 border-t-indigo-600 rounded-full animate-spin"></div>
            </div>
        );
    }

    if (!user) {
        return null; // Will redirect to login
    }

    return (
        <div style={{ 
            all: 'unset', 
            fontFamily: 'system-ui, -apple-system, sans-serif',
            color: '#111827',
            backgroundColor: 'transparent'
        }}>
            <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-200">
                {/* Persistent Sidebar */}
                <CommonSidebar 
                    user={user}
                    onLogout={handleLogout}
                    sidebarCollapsed={sidebarCollapsed}
                    setSidebarCollapsed={setSidebarCollapsed}
                    mobileMenuOpen={mobileMenuOpen}
                    setMobileMenuOpen={setMobileMenuOpen}
                />

                {/* Main Content Area - This will change based on route */}
                <main className={`transition-all duration-300 min-h-screen ${
                    sidebarCollapsed ? 'lg:ml-20' : 'lg:ml-72'
                } ml-0`}>
                    <Outlet context={{ 
                        user, 
                        handleLogout,
                        sidebarCollapsed,
                        setSidebarCollapsed,
                        mobileMenuOpen,
                        setMobileMenuOpen
                    }} />
                </main>
            </div>
        </div>
    );
};

export default Layout;
